module.exports = __webpack_public_path__ + "static/Woodbury_Shortridge.a4d3e69a.pdf";


//////////////////
// WEBPACK FOOTER
// ./static/img/Woodbury_Shortridge.pdf
// module id = 1892
// module chunks = 263791100135453